import {
  Header,
  SliderRowExplore,
  // Partners,
  WhyHim,
  ContactUs,
} from "../../app/features/Home";
const Home = () => {
  return (
    <>
      <Header />
      <SliderRowExplore />
      {/* <SliderRow title='الأكثر تسجيلا' link='/' /> */}
      <WhyHim />
      {/* <Partners /> */}
      <ContactUs />
      {/* <Teachers /> */}
      {/* <GredCard title="الأكثر تحميلا" link='/' data={dataCardTwo} /> */}
      {/* <AboutUs /> */}
    </>
  );
};

export default Home;
